import styled from '@emotion/styled';

import S from 'app/components/Button/Button.styled';
import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall } = breakpoints;

const ButtonsGroup = styled.div`
  label: ButtonsGroup;

  --button-block-margin: 0.375rem;
  --button-inline-margin: 0;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: calc(-1 * var(--button-block-margin))
    calc(-1 * var(--button-inline-margin));

  ${S.Button} {
    flex: 1 1 100%;
    margin: var(--button-block-margin) var(--button-inline-margin);
  }

  @media (${widthSmall}) {
    --button-inline-margin: 0.3125rem;

    display: inline-flex;

    ${S.Button} {
      flex: unset;
    }
  }
`;

export default ButtonsGroup;
